import React from 'react';

const GiftaidPopupText = () => (
  <>
    <h2>Giftaid it</h2>

    <ul>
      <li>
        You must pay an amount of Income Tax and/or Capital Gains Tax for each tax year (6 April to
        5 April) that is at least equal to the amount of tax that all the charities or Community
        Amateur Sports Clubs (CASCs) that you donate to will reclaim on your gifts for that tax
        year. I understand that if I pay less Income and / or Capital Gains tax than the amount of
        Gift Aid claimed on my all of my donations in the relevant tax year it is my responsibility
        to pay the difference.
      </li>

      <li>I understand that other taxes such as VAT and Council Tax do not qualify.</li>
      <li>
        You can cancel this declaration at any time by notifying us on the Supporter Care number
        08000324001
      </li>

      <li>
        If you pay tax at the higher rate you can claim further tax relief in your Self-Assessment
        tax return.
      </li>

      <li>Please notify us of any changes in your name and/or address.</li>

      <li>
        Please notify us if you no longer pay sufficient tax on your income and/or capital gains
      </li>
    </ul>
  </>
);

export default GiftaidPopupText;
